<template>
  <div class="currency-input__wrapper">
    <input
      ref="input"
      :value="value"
      @input="updateValue($event.target.value)"
      :placeholder="placeholder"
      :name="name"
      type="tel"
      class="currency-input__input"
    />
    <div class="currency-input__currency">{{ currency }}</div>
  </div>
</template>

<script>
export default {
  name: 'CurrencyInput',

  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: '',
    },
  },

  computed: {
    placeholder() {
      return '_'.repeat(20);
    },
  },

  methods: {
    updateValue: function (value) {
      this.$emit('input', isNaN(parseInt(value)) ? null : parseInt(value));
    },
  },
};
</script>

<style scoped>
input::-webkit-input-placeholder {
  padding-right: 10px;
  text-align: right;
  letter-spacing: -2px;
}
input:-moz-placeholder {
  padding-right: 10px;
  text-align: right;
  letter-spacing: -2px;
}
.currency-input__wrapper {
  display: inline-flex;
  max-width: 100%;
}
.currency-input__input {
  border: 1px solid #000;
  border-right: 0;
  max-width: 100%;
}
.currency-input__currency {
  flex: 0 0 auto;
  border: 1px solid #000;
  border-left: 0;
  background: #fff;
  padding: 10px;
}
</style>
